import { render, staticRenderFns } from "./ImportTransactions.vue?vue&type=template&id=0b8aaea4&scoped=true&"
import script from "./ImportTransactions.vue?vue&type=script&lang=js&"
export * from "./ImportTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8aaea4",
  null
  
)

export default component.exports